module.exports = __webpack_public_path__ + "img/SMT_54_Ms_Radha_DO_Sockalingam.e9521e56.jpg";